import React from 'react';


import logo from '../Assets/command-line.png';

import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import { Link as Scroll } from 'react-scroll';
import { Link } from 'react-router-dom'




class Header extends React.Component {
	render() {
		return (
			<Navbar expand="lg" className="nav navbarFront" fixed="top">
				<Link to='/'>
					<Navbar.Brand className="navtitle" style={{ margin: '10px' }}>
						<img src={logo} className="logoIcon" alt="Compile Labs Logo - Mobile/Web Design and Development" />
					</Navbar.Brand>
				</Link>

				<Navbar.Brand className="navtitle">Compile Labs</Navbar.Brand>

			
				<Nav className="ml-auto">


					<Scroll activeClass="active" to="product" spy={true} smooth={true} offset={100} duration={500} style={{cursor: "pointer"}}>
						<Nav className="linkButton">Contact Us</Nav>
					</Scroll>

				</Nav>
			</Navbar>
		);
	}
}




export default Header;